@for (group of variantGroups(); track group) {
  <div class="variants-group"
    [class.variants-group--big]="isBigSize()"
    >
    <div class="variants-group__label-container" [class.variants-group__label-container--big]="isBigSize()">
      <span class="variants-group__label" [class.variants-group__label--big]="isBigSize()">
        {{ group.label }}
      </span>
      @if (isBigSize()) {
        : {{ group.selectedVariantLabel }}
      }
    </div>
    <div class="variants-group__variants">
      @for (variant of group.variants; track variant) {
        <a
          class="variants-group__variant"
          [class.variants-group__variant--big]="isBigSize()"
          [routerLink]="['/', variant.slug]"
          routerLinkWithLang
        >
          @if (group.hasColor) {
            <span class="variants-group__color-container tooltip-container"
              [class.variants-group__color-container--big]="isBigSize()"
              [class.variants-group__color-container--selected]="variant.isSelected"
              [class.variants-group__color-container--out-of-stock]="!variant.isInStock"
              >
              <span class="variants-group__color"
                [class.variants-group__color--big]="isBigSize()"
                [style.background]="variant.color"
              ></span>
              <span class="tooltip variants-group__tooltip">{{ variant.label }}</span>
            </span>
          } @else {
            <span class="variants-group__variant-label"
              [class.variants-group__variant-label--big]="isBigSize()"
              [class.variants-group__variant-label--selected]="variant.isSelected"
              [class.variants-group__variant-label--out-of-stock]="!variant.isInStock"
              >
              {{ variant.label }}
            </span>
          }
        </a>
      }
    </div>
  </div>
}
